import {HttpClient, HttpHeaders} from '@angular/common/http';
import {
    API_BASE,
    API_SALES,
    API_SALES_DATA,
    ID_PRICE_BOOK,
    AUTH_SALES_API
} from '../../app.constants';
import {DOMAIN} from '../../app.constants';
import {BehaviorSubject, Observable} from 'rxjs';
import * as jwt_decode from 'jwt-decode';
import {ISalesToken} from '../interfaces/sales-token.interface';
import {ResultApi} from '../viewModel/result_api.model';


export interface Auth { id_token: string; }
export const authApi = {username: 'apisitemontreal', password: 'pu4c3550'};
export const authSalesApiUrl = AUTH_SALES_API;
export class BaseService {
    // tslint:disable-next-line:variable-name
    private _httpClient: HttpClient;
    private currentApiSubject: BehaviorSubject<Auth>;
    public currentApi: Observable<Auth>;
    private currentSalesApiSubject: BehaviorSubject<ISalesToken>;
    public currentSalesApi: Observable<ISalesToken>;
    public url = API_BASE;
    public salesDataUrl = API_SALES_DATA;
    public domain = DOMAIN;
    public endpoint: string;
    public salesUrl = API_SALES;
    public idPriceBook = ID_PRICE_BOOK;

    constructor(httpClient: HttpClient, endpoint: string = '') {
        this._httpClient = httpClient;
        this.endpoint = endpoint;
        this.currentApiSubject = new BehaviorSubject<Auth>(JSON.parse(localStorage.getItem('currentApi')));
        this.currentApi = this.currentApiSubject.asObservable();
        this.currentSalesApiSubject = new BehaviorSubject<ISalesToken>(JSON.parse(localStorage.getItem('currentSalesApi')));
        this.currentSalesApi = this.currentSalesApiSubject.asObservable();
    }

    public get currentApiValue(): Auth {
        return this.currentApiSubject.value;
    }

    public get currentSalesTokenValue(): ISalesToken {
        return this.currentSalesApiSubject.value;
    }

    hasToken(): boolean {
        return !!this.currentApiValue;
    }

    hasSalesToken(): boolean {
        return !!this.currentSalesTokenValue;
    }

    isTokenExpired(token: string): boolean {
        const tokenDecode = this.decodePayloadJWT(token);
        if (tokenDecode) {
            const currentTime = new Date().getTime();
            const tokenTime = tokenDecode.exp * 1000;
            return tokenTime < currentTime;
        }
        return true;
    }

    private isSalesTokenExpired(): boolean {
        const currentTime = new Date().getTime();
        const validade_token = this.currentSalesTokenValue.validade_token;
        const tokenTime = new Date(validade_token).getTime();
        return tokenTime < currentTime;
    }

    decodePayloadJWT(token: string): any {
        try {
            if (token) {
                return jwt_decode(token);
            }
            return null;
        } catch (e) {
            return null;
        }
    }

    public async getHttpOptions() {
        const token = await this.getToken();
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization-Api': `Bearer ${token}`,
            })
        };
    }

    public async  getHttpOptionsSales(reload = false) {
        const salesToken = await this.getSalesToken(reload);
        return {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${salesToken}`,
            })
        };
    }

    public async getToken() {
        let service: Auth;
        if (!this.hasToken()) {
            service = await this.authApi();
        } else {
            if (this.isTokenExpired(this.currentApiValue.id_token)) {
                service = await this.authApi();
            }
        }
        return (service !== undefined) ? service.id_token : this.currentApiValue.id_token;
    }

    public async getSalesToken(reload = false) {
        let service: ISalesToken;
        if (!this.hasSalesToken() || reload) {
            service = await this.authSalesApi();
        } else {
            if (this.isSalesTokenExpired()) {
                service = await this.authSalesApi();
            }
        }
        return (service !== undefined) ? service.token : this.currentSalesTokenValue.token;
    }

    authApi(): Promise<Auth> {
        return this._httpClient.post<Auth>(`${API_BASE}/sistema/authenticate`, authApi)
            .toPromise()
            .then((api: any) => {
                if (api) {
                    localStorage.setItem('currentApi', JSON.stringify(api));
                    this.currentApiSubject.next(api);
                    return api;
                }
                return null;

            }).catch((err: any) => {
                localStorage.removeItem('currentApi');
                return err;
            });
    }

    authSalesApi(): Promise<ISalesToken> {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            })
        };
        return this._httpClient.get<ISalesToken>(authSalesApiUrl, options)
            .toPromise()
            .then((api: any) => {
                if (api) {
                    const result = {
                        token: '',
                        validade_token: ''
                    };
                    if (typeof api === 'string') {
                        result.token = api;
                        const newDate =  new Date();
                        newDate.setHours(newDate.getHours() + 1);
                        result.validade_token = newDate.toString();
                    } else {
                        result.token = api.token;
                        result.validade_token = api.validade_token;
                    }
                    localStorage.setItem('currentSalesApi', JSON.stringify(result));
                    this.currentSalesApiSubject.next(result);
                    return result;
                }
                return null;
            })
            .catch((err: any) => {
                localStorage.removeItem('currentSalesApi');
                return err;
            });
    }

    response(data: any, status: number = 202, error: any = null) {
        if (data) {
            return new ResultApi().toResult({ status, data, error });
        }
        return null;
    }

    path() {
        return `${this.url}/${this.endpoint}`;
    }

}
